import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Почему{' '}
              <span className="italic text-accent-500">YOYBUY</span>
              <br />
              Spreadsheet?
            </h2>
            <p className="mt-6 text-base text-foreground-600 leading-relaxed max-w-md">
              YOYBUY Spreadsheet — это не просто таблица. Это полноценная система для умных покупок из Китая, которая помогает экономить время и деньги.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-3 gap-0 divide-x divide-background-300">
            <div className="px-5 md:px-8 text-center">
              <div className="text-4xl md:text-5xl font-bold text-accent-500 font-mono">5000<span className="text-accent-400">+</span></div>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {t('trust.stat_1')}
              </p>
            </div>
            <div className="px-5 md:px-8 text-center">
              <div className="text-4xl md:text-5xl font-bold text-accent-500 font-mono">14<span className="text-accent-400">+</span></div>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {t('trust.stat_2')}
              </p>
            </div>
            <div className="px-5 md:px-8 text-center">
              <div className="text-4xl md:text-5xl font-bold text-accent-500 font-mono">120<span className="text-accent-400">+</span></div>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {t('trust.stat_3')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}